import React, {Component} from 'react';
import{Container} from './styles';
import {Link} from 'react-router-dom';
import Menu from '../Menu';

import Config from '../../assets/icones/icon_config.svg';
import Home from '../../assets/icones/icon_home.svg';
import Produtos from '../../assets/icones/icon_products.svg';
import Promo from '../../assets/icones/icon_promo.svg';
import Burguer from '../../assets/icones/icon_menu.svg';
import Invoice from '../../assets/icones/invoice.png';
import Ajuda from '../../assets/icones/icon_ajuda.svg';


import BrancoConfig from '../../assets/icones/brancos/icon_config.svg';
import BrancoHome from '../../assets/icones/brancos/icon_home.svg';
import BrancoProdutos from '../../assets/icones/brancos/icon_products.svg';
import BrancoPromo from '../../assets/icones/brancos/icon_promo.svg';
import Financeiro from '../../assets/icones/icon_financeiro.svg';
import BrancoInvoice from '../../assets/icones/brancos/invoice.png';
import BrancoAjuda from '../../assets/icones/brancos/icon_ajuda.svg';

export default class FooterNav extends Component {

    constructor(props) {
        super(props);
        this.local = ["", ((props.location.pathname).split('/', 2))[1]]
        this.state = {
            path: this.local,
            isOpen: false
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            // console.log(`The current URL is ${(location.pathname).split('/', 2)}${location.search}${location.hash}`);
            this.setState({
                path: (location.pathname).split('/', 2)
            })
            // console.log(`The last navigation action was ${action}`)
      })
    }

    handlerBurguer() {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        return(
            <>
            <div style={{ position: 'relative' }}>
                <Menu
                    close={() => this.handlerBurguer()} 
                    open={this.state.isOpen}/>
            </div>
            <Container>

                <div className="telas">

                    {/* <Link to="/"  */}
                    <Link
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "" ? "telaatual" : "tela-not-allowed"}>
                        <img alt="" src={this.state.path[1] === "" ? BrancoHome : Home}
                        className="icones"/>
                    </div>
                    </Link>
                    
                    {/* <Link to="aval"
                    style={{ textDecoration: 'none' }}>
                    <div className="tela">
                    <img src={Rating} 
                        className="icones"/>
                        <h3>
                        Avaliações
                        </h3>
                    </div>
                    </Link> */}
                    
                    {/* <Link to="relatorio"
                    style={{ textDecoration: 'none' }}>
                    <div className="tela">
                    <img src={Report} 
                        className="icones"/>
                        <h3>
                        Relatórios
                        </h3>
                    </div> 
                    </Link> */}
                    
                    <Link to="/produtos"
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "produtos" ? "telaatual" : "tela"}>
                    <img alt="" src={this.state.path[1] === "produtos" ? BrancoProdutos : Produtos} 
                        className="icones"/>
                    </div>
                    </Link>
                    
                    <Link to ="promocoes"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "promocoes" ? "telaatual" : "tela"}>
                        <img alt="" src={this.state.path[1] === "promocoes" ? BrancoPromo : Promo} 
                            className="icones"/>
                        </div>
                    </Link>
                    
                    <Link 
                    to="/configuracoes"
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "configuracoes" ? "telaatual" : "tela"}>
                    <img alt="" src={this.state.path[1] === "configuracoes" ? BrancoConfig : Config} 
                        className="icones"/>
                    </div>
                    </Link>

                    {/* <Link 
                    to="/ajuda"
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "ajuda" ? "telaatual" : "tela"}>
                    <img alt="" src={this.state.path[1] === "ajuda" ? BrancoAjuda : Ajuda} 
                        className="icones"/>
                    </div>
                    </Link> */}

                    <Link to="financeiro"
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "financeiro" ? "telaatual" : "tela"}>
                    <img alt="" src= {this.state.path[1] === "financeiro" ? BrancoInvoice : Invoice}
                        className="icones"/>
                      
                    </div>  
                    </Link>

                    <div 
                        className="tela"
                        onClick={() => {this.handlerBurguer()}
                            // this.handlerBurguer()
                        }
                        >
                        <img alt="" src={Burguer} 
                            className="icones"/>
                    </div>

                    {/* <Link to="treinamento"
                    style={{ textDecoration: 'none' }}>
                    <div className="tela">
                    <img src={Training} 
                        className="icones"/>
                        <h3>
                        Treinamento
                        </h3>
                    </div> 
                    </Link> */}

                    {/* <Link to="treinamento"
                    style={{ textDecoration: 'none' }}>
                    <div className="tela">
                    <img src={Training} 
                        className="icones"/>
                        <h3>
                        Treinamento
                        </h3>
                    </div> 
                    </Link> */}
                    
                    
                   {/*  <hr/>

                    <div className="tela">
                    <img src={Logout} 
                        className="icones"/>
                        <h3>
                        Sair
                        </h3>
                    </div> */}
                </div>

            </Container>
            </>
        )
    }
}